import { defineMessages } from 'react-intl'

export default defineMessages({
  noOptions: {
    id: 'component.Inputs.Select.noOptions',
    defaultMessage: 'No options',
  },
  loading: {
    id: 'component.Inputs.Select.loading',
    defaultMessage: 'Loading...',
  },
  searchPlaceholder: {
    id: 'component.Inputs.Select.searchPlaceholder',
    defaultMessage: 'Search',
  },
})
